export const SymmetricKeySize = 32;
export const IvSize = 12;
export const TagSize = 16;
export let symmetric = {};
import('./browser')
    .then((mod) => {
    symmetric = mod;
})
    .catch((eBrowser) => {
    import('./node')
        .then((mod) => {
        symmetric = mod;
    })
        .catch((eNode) => {
        throw `Could not load any symmetric crypto modules: ${eBrowser}, ${eNode}`;
    });
});
//# sourceMappingURL=index.js.map